import { ElementRef, Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LorenScrollService {
  private scrollableContent: ElementRef;

  setScrollableContent(el: ElementRef) {
    this.scrollableContent = el;
  }

  getScrollableContent(): ElementRef {
    return this.scrollableContent;
  }

  scrollToTop() {
    if (!this.scrollableContent) {
      return;
    }

    if (!this.scrollableContent.nativeElement) {
      return;
    }

    this.scrollableContent.nativeElement.scrollTop = 0;
    this.scrollableContent.nativeElement.scrollLeft = 0;
  }
}
